import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'
// импорт api
import usersApi from '@/api/usersApi'

// импорт модулей
import dictionaries from './modules/dictionaries'
// сотрудники
import userRoles from './modules/Users/user-roles'
import userCreatePage from './modules/Users/user-create-page'
import userUpdatePage from './modules/Users/user-update-page'
import userListPage from './modules/Users/user-list-page'
import subordinatesListPage from './modules/Users/subordinates-list-page'
import departmentsTreePage from './modules/Users/departments-tree-page'
import departmentCreatePage from './modules/Users/department-create-page'
import userGroupsPage from './modules/Users/user-groups-page'
// справочники
import positionListPage from './modules/Users/Directories/position-list-page'
import employmentListPage from './modules/Users/Directories/employment-list-page'
import statusListPage from './modules/Users/Directories/status-list-page'
import scheduleListPage from './modules/Users/Directories/schedule-list-page'
// договоры
import contractListPage from './modules/Contract/contracts-list-page'
import contractUpdatePage from './modules/Contract/contract-update-page'
import contractTypeListPage from './modules/Contract/contract-type-list-page'
import contractStageListPage from './modules/Contract/contract-stage-list-page'
import contractStatusListPage from './modules/Contract/contract-status-list-page'
import contractProjectListPage from './modules/Contract/contract-project-list-page'
// контрагенты
import contractorListPage from './modules/Contractor/contractor-list-page'
import contractorUpdatePage from './modules/Contractor/contractor-update-page'
import contractorFormListPage from './modules/Contractor/contractor-form-list-page'
import contractorStatusListPage from './modules/Contractor/contractor-status-list-page'
import contractorTypeListPage from './modules/Contractor/contractor-type-list-page'

Vue.use(Vuex)

/* в авторизацию устанавливается токен от залогиненного сотрудника */
export const configMultipart = { headers: { 'Content-Type': 'multipart/form-data', Accept: 'application/json', Authorization: 'Bearer api_key' } }
export const config = { headers: { Accept: 'application/json', Authorization: 'Bearer api_key' } }

export const url = process.env.VUE_APP_API_URL

export default new Vuex.Store({
  // TODO: включить и исправить ошибки, преимущественно в авторизации
  /* strict: true, */
  state: {
    appData: {
      authData: {
        login: '',
        password: '',
        /* login: 'admin@admin.ltd',
        password: 'Ghbdtn123', */
        validation: {
          login: {},
          password: {}
        }
      },
      loginErrorIsActive: false,
      currentUser: {
        id: null,
        api_key: null,
        logged_in: false
      },
      currentUserData: {
        id: null,
        avatar: null,
        full_name: 'Вход не выполнен',
        isLoading: true,
        menu: {
          is_active: false,
          list: []
        }
      },
      mediaBreakpoint: 'desktop',
      // флаг хранит тип ос IOS или default
      userAgent: 'default',
      mainMenu: {
        // флаг для мобилки отвечает за выезд меню
        is_active_mobile: false,
        // а флаг активации отвечает за показ списка плагинов внутри меню
        is_active: true,
        list: []
      },
      /* меню формируются через мутацию */
      sectionMenus: {
        usersMenu: {},
        contractMenu: {},
        contractorsMenu: {},
        directoriesMenu: {}
      },
      activeMenu: {}
    }
  },
  getters: {
    // Авторизация
    authData: state => state.appData.authData,
    currentUser: state => {
      return state.appData.currentUser
    },
    currentUserData: state => state.appData.currentUserData,
    loginErrorIsActive: state => state.appData.loginErrorIsActive,
    // Меню
    mainMenu: state => state.appData.mainMenu,
    activeMenu: state => state.appData.activeMenu,

    getMediaBreakpoint: state => state.appData.mediaBreakpoint,
    getUserAgent: state => state.appData.userAgent
  },
  mutations: {
    // АВТОРИЗАЦИЯ
    SET_AUTH_LOGIN: (state, login) => {
      state.appData.authData.login = login.replace(/\s/g, '')
    },
    SET_AUTH_PASSWORD: (state, password) => {
      state.appData.authData.password = password.replace(/\s/g, '')
    },
    '[index] CLEAR_LOGIN_FORM': (state) => {
      state.appData.authData.login = ''
      state.appData.authData.password = ''
    },
    SET_AUTH_VALIDATION: (state, errors) => {
      if (errors.email) {
        state.appData.authData.validation.login = {
          type: 'error',
          message: errors.email[0]
        }
      }
      if (errors.password) {
        state.appData.authData.validation.password = {
          type: 'error',
          message: errors.password[0]
        }
      }
    },
    LOGIN_FORM_CLEAR_VALIDATION: (state, input) => {
      if (input === 'login') {
        state.appData.authData.validation.login = {}
      } else if (input === 'password') {
        state.appData.authData.validation.password = {}
      }
    },
    // записываем данные о залогиненом пользователе в стейт и localStorage
    LOG_IN: (state, user) => {
      const currentUser = {
        id: user.id,
        api_key: user.api_key,
        /* role: user.role ? user.role : null, */
        // TODO: вернуть когда Паша включит роли
        role: 'administrator',
        logged_in: true
      }
      /* обновляем конфиги запросов */
      configMultipart.headers.Authorization = `Bearer ${user.api_key}`
      config.headers.Authorization = `Bearer ${user.api_key}`

      state.appData.currentUser = currentUser
      localStorage.currentUserId = currentUser.id
      // сохраняем ключ в localStorage (может быть не верное решение с точки зрения безопасности)
      localStorage.currentUserKey = currentUser.api_key
      localStorage.currentUserLogged = currentUser.logged_in
    },
    GET_CURRENT_USER_DATA: (state, data) => {
      state.appData.currentUserData.id = data.id
      state.appData.currentUserData.full_name = data.profile && (data.profile.name || data.profile.surname) ? `${data.profile.surname ? data.profile.surname : ''} ${data.profile.name ? data.profile.name : ''}` : 'Без имени'
      state.appData.currentUserData.avatar = (data.avatar && data.avatar.file_size) ? data.avatar.url : null
      state.appData.currentUserData.menu.list = [
        {
          title: 'Личные данные',
          link: `/user/info/${data.id}/personal`
        }
      ]
      state.appData.currentUserData.isLoading = false
    },
    GET_CURRENT_USER_DATA_FAILURE: (state) => {
      state.appData.currentUserData.isLoading = false
    },
    LOG_OUT: (state) => {
      // устанавливаем дефолтные значения текущего пользователя
      state.appData.currentUser = {
        id: null,
        api_key: null,
        logged_in: false
      }
      // устанавливаем дефолтные значения данных текущего пользователя
      state.appData.currentUserData = {
        id: null,
        avatar: null,
        full_name: 'Вход не выполнен',
        isLoading: true,
        menu: {
          // ставим меню в положение active так-как при нажатии оно сменяется на противоположное и при логауте остается открытым
          is_active: true,
          list: []
        }
      }
      localStorage.removeItem('currentUserId')
      localStorage.removeItem('currentUserSU')
      localStorage.removeItem('currentUserKey')
      localStorage.removeItem('currentUserToken')
      localStorage.removeItem('currentUserLogged')
    },
    SHOW_LOGIN_ERROR_MESSAGE: state => {
      state.appData.loginErrorIsActive = true
    },
    HIDE_LOGIN_ERROR_MESSAGE: state => {
      state.appData.loginErrorIsActive = false
    },

    // МЕНЮ
    TOGGLE_HEADER_MENU: (state) => {
      state.appData.currentUserData.menu.is_active = !state.appData.currentUserData.menu.is_active
    },
    CLOSE_HEADER_MENU: (state) => {
      state.appData.currentUserData.menu.is_active = false
    },
    MAIN_MENU_INITIALIZE: state => {
      state.appData.mainMenu.list = [
        {
          icon: '/img/svg/contracts__icon.svg',
          title: 'Сотрудники',
          route: 'usersMenu'
          // colorFirst: '#E6B537',
          // colorSecond: '#EF4F3D'
        }
      ]

      const roleAccessContracts = state.userRoles.contracts.access
      if (roleAccessContracts) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/contracts__icon.svg',
          title: 'Договоры',
          route: 'contractMenu'
          // colorFirst: '#DA60A3',
          // colorSecond: '#EF424D'
        })
      }

      const roleAccessContractors = state.userRoles.contractors.access
      if (roleAccessContractors) {
        state.appData.mainMenu.list.push({
          icon: '/img/svg/contracts__icon.svg',
          title: 'Контрагенты',
          route: 'contractorsMenu'
          // colorFirst: '#E7205B',
          // colorSecond: '#4F26A8'
        })
      }
    },
    MENU_INITIALIZE: (state) => {
      // const userId = state.appData.currentUser.id || localStorage.getItem('currentUserId')
      // const roleAccessGroups = state.userRoles.userGroups.access
      // const roleAccessSubordinates = state.userRoles.users.subordinates
      const roleAccessDirectories = state.userRoles.directories.access

      state.appData.sectionMenus.usersMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/contracts__icon.svg'
          // colorFirst: '#E6B537',
          // colorSecond: '#EF4F3D'
        },
        title: 'Сотрудники',
        subtitle: null,
        list: [
          {
            title: 'Все сотрудники',
            link: '/user/list'
          }
          // {
          //   title: 'Структура организации',
          //   link: '/departments/tree'
          // }
        ]
      }
      // if (roleAccessSubordinates) {
      //   state.appData.sectionMenus.usersMenu.list.push({
      //     title: 'Мои сотрудники',
      //     link: `/user/subordinates-list/${userId}`,
      //     is_parent: false
      //   })
      // }
      // if (roleAccessGroups) {
      //   state.appData.sectionMenus.usersMenu.list.push({
      //     title: 'Группы',
      //     link: '/user/groups',
      //     is_parent: false
      //   })
      // }
      if (roleAccessDirectories) {
        state.appData.sectionMenus.usersMenu.list.push({
          title: 'Справочники',
          link: null,
          sub_menu: 'directoriesMenu'
        })
      }

      // TODO: если юзер не имеет доступов к разделам - сделать так, чтобы он не мог переходить по этим роутам
      state.appData.sectionMenus.contractMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/contracts__icon.svg'
          // colorFirst: '#DA60A3',
          // colorSecond: '#EF424D'
        },
        title: 'Договоры',
        subtitle: null,
        list: [
          {
            title: 'Договоры',
            link: '/contracts/list'
          },
          {
            title: 'Стадии договора',
            link: '/contracts/stages'
          },
          {
            title: 'Статусы договора',
            link: '/contracts/status'
          },
          {
            title: 'Типы договора',
            link: '/contracts/types'
          },
          {
            title: 'Проекты',
            link: '/contracts/projects'
          }
        ]
      }
      state.appData.sectionMenus.contractorsMenu = {
        is_root: true,
        icon: {
          img: '/img/svg/contracts__icon.svg'
          // colorFirst: '#E7205B',
          // colorSecond: '#4F26A8'
        },
        title: 'Контрагенты',
        subtitle: null,
        list: [
          {
            title: 'Контрагенты',
            link: '/contractors/list'
          },
          {
            title: 'Статусы контрагента',
            link: '/contractors/status'
          },
          {
            title: 'Типы контрагентов',
            link: '/contractors/types'
          },
          {
            title: 'Орг. прав. формы предприятия',
            link: '/contractors/forms'
          }
        ]
      }

      state.appData.sectionMenus.directoriesMenu = {
        is_root: false,
        parentMenu: 'usersMenu',
        icon: null,
        title: 'Справочники',
        subtitle: null,
        list: [
          {
            title: 'Должности',
            link: '/user/directories/positions'
          },
          {
            title: 'Виды занятости',
            link: '/user/directories/employments'
          },
          {
            title: 'Статусы',
            link: '/user/directories/statuses'
          },
          {
            title: 'Графики работы',
            link: '/user/directories/schedules'
          }
        ]
      }
    },
    SET_CURRENT_MENU: (state, currentRootPath) => {
      const usersMenu = state.appData.sectionMenus.usersMenu
      const directoriesMenu = state.appData.sectionMenus.directoriesMenu
      const contractMenu = state.appData.sectionMenus.contractMenu
      const contractorsMenu = state.appData.sectionMenus.contractorsMenu

      state.appData.mainMenu.is_active = false
      switch (currentRootPath) {
        case 'user':
          state.appData.activeMenu = usersMenu
          break
        case 'directories':
          state.appData.activeMenu = directoriesMenu
          break
        case 'contracts':
          state.appData.activeMenu = contractMenu
          break
        case 'contractors':
          state.appData.activeMenu = contractorsMenu
          break
        default:
          state.appData.mainMenu.is_active = true
          break
      }
    },
    TOGGLE_MAIN_MENU: (state) => {
      state.appData.mainMenu.is_active = !state.appData.mainMenu.is_active
    },
    TOGGLE_MAIN_MENU_MOBILE: (state) => {
      state.appData.mainMenu.is_active_mobile = !state.appData.mainMenu.is_active_mobile
    },
    CLOSE_MAIN_MENU_MOBILE: (state) => {
      state.appData.mainMenu.is_active_mobile = false
    },
    SWITCH_MENU: (state, data) => {
      const currentRouteName = router.currentRoute.name

      switch (data.menu) {
        case 'usersMenu':
          if (currentRouteName !== 'UserList') {
            router.push({ name: 'UserList' })
          }
          break
        case 'directoriesMenu':
          if (currentRouteName !== 'PositionList') {
            router.push({ name: 'PositionList' })
          }
          break
        case 'contractMenu':
          if (currentRouteName !== 'ContractList') {
            router.push({ name: 'ContractList' })
          }
          break
        case 'contractorsMenu':
          if (currentRouteName !== 'ContractorList') {
            router.push({ name: 'ContractorList' })
          }
          break
        default: break
      }
      state.appData.activeMenu = state.appData.sectionMenus[`${data.menu}`]
      console.log('isSubmenu')
      if (!data.isSubmenu) {
        console.log('!data.isSubmenu')
        state.appData.mainMenu.is_active = !state.appData.mainMenu.is_active
      }
    },
    SET_CURRENT_MEDIA_BREAKPOINT: (state, breakpoint) => {
      state.appData.mediaBreakpoint = breakpoint
    },
    SET_CURRENT_USER_AGENT: (state, type) => {
      state.appData.userAgent = type
    }
  },
  actions: {
    closeAllPopups ({ commit }) {
      switch (router.currentRoute.name) {
        case 'UserList':
          // commit('userListPage/CLOSE_USER_LIST_CONTROLS')
          // commit('userListPage/CLOSE_USERS_PAGE_LIST')
          break
        case 'DepartmentsTree':
          commit('CLOSE_DEPARTMENTS_TREE_ITEM_POPUPS')
          break
        case 'Feed':
          commit('HIDE_FEED_MESSAGE_AREA')
          commit('CLOSE_FEED_MESSAGE_LINK_TOOLTIP')
          commit('CLOSE_FEED_MESSAGE_TAG_TOOLTIP')
          commit('CLOSE_FEED_MESSAGE_RECIPIENTS')
          commit('CLOSE_FEED_POST_CONTROLS')
          commit('CLOSE_FEED_FILTER')
          commit('CLOSE_FEED_EVENT_MORE_USERS')
          break
        case 'PositionList':
          commit('CLOSE_POSITION_LIST_CONTROLS')
          break
        case 'EmploymentList':
          commit('CLOSE_EMPLOYMENT_LIST_CONTROLS')
          break
        case 'StatusList':
          commit('CLOSE_STATUS_LIST_CONTROLS')
          break
        case 'ScheduleList':
          commit('CLOSE_SCHEDULE_LIST_CONTROLS')
          break
        case 'TaskList':
          commit('CLOSE_TASK_BOARD_COLOR_PICKER')
          commit('CLOSE_TASK_LIST_PAGE_LIST')
          commit('CLOSE_TASK_LIST_FILTER_DATE_CREATED')
          commit('CLOSE_TASK_LIST_FILTER_DATE_FINISH')
          commit('CLOSE_TASK_LIST_FILTER_LIST')
          commit('CLOSE_TASK_LIST_ITEMS_CONTROLS')
          commit('CLOSE_TASK_BOARD_COLUMN_CONTROLS')
          commit('CLOSE_TASK_BOARD_NEW_COLUMN_FORM')
          break
        case 'TaskInfo':
          commit('CLOSE_TASK_INFO_COMMENTS_LINK_TOOLTIP')
          commit('CLOSE_TASK_INFO_COMMENTS_TAG_TOOLTIP')
          commit('CLOSE_TASK_INFO_COMMENTS_ITEMS_CONTROLS')
          commit('CLEAR_TASK_INFO_COMMENTS_VALID')
          break

          // договоры
        case 'ContractList':
          commit('contractListPage/TOGGLE_CONTRACTS_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractStageList':
          commit('contractStageListPage/TOGGLE_CONTRACTS_STAGE_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractTypeList':
          commit('contractTypeListPage/TOGGLE_CONTRACTS_TYPE_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractStatusList':
          commit('contractStatusListPage/TOGGLE_CONTRACTS_STATUS_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractProjectList':
          commit('contractProjectListPage/TOGGLE_CONTRACTS_PROJECT_LIST_ITEM_CONTROLS', null)
          break
          // /договоры

          // контрагенты
        case 'ContractorList':
          commit('contractorListPage/TOGGLE_CONTRACTORS_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractorsStatusList':
          commit('contractorStatusListPage/TOGGLE_CONTRACTORS_STATUS_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractorsTypeList':
          commit('contractorTypeListPage/TOGGLE_CONTRACTORS_TYPE_LIST_ITEM_CONTROLS', null)
          break
        case 'ContractorsFormList':
          commit('contractorFormListPage/TOGGLE_CONTRACTORS_FORMS_LIST_ITEM_CONTROLS', null)
          break
        default: break
      }
      commit('CLOSE_HEADER_MENU')
    },

    // АВТОРИЗАЦИЯ
    setAuthLogin ({ commit }, login) {
      commit('SET_AUTH_LOGIN', login)
    },
    setAuthPassword ({ commit }, password) {
      commit('SET_AUTH_PASSWORD', password)
    },
    logIn (context) {
      const authData = {
        login: context.state.appData.authData.login,
        password: context.state.appData.authData.password
      }

      axios.post(`${url}/users/auth?email=${authData.login}&password=${authData.password}`, config).then(response => {
        context.commit('LOG_IN', response.data.data)
        context.commit('[index] CLEAR_LOGIN_FORM')
        // при входе и выходе редиректим домой, чтобы не сбивалась логика инициализации меню,
        // так как оно в этих случаях не правильно устанавливает текущий раздел (мутация SET_CURRENT_MENU)
        if (router.currentRoute.path !== '/') {
          router.push({ path: '/' })
        }

        usersApi.getCurrentUser().then(response => {
          context.commit('[roles] SET_RIGHTS', response.data.data.roles)
          context.commit('GET_CURRENT_USER_DATA', response.data.data)
          context.dispatch('initialiseMenu')
        }).catch((error) => {
          console.log('Ошибка авторизации:', error.response)
          context.dispatch('logOut').then(() => {
            context.commit('GET_CURRENT_USER_DATA_FAILURE')
            context.commit('SHOW_LOGIN_ERROR_MESSAGE')
          })
        })
        // запускаем пинги для обновления статуса онлайн
        this.dispatch('renewUserAuthTime')
      }).catch(error => {
        console.log(error.response)
        if (error.response.data.result_code === 'UNTF') {
          context.commit('SET_AUTH_VALIDATION', { email: [error.response.data.result_message] })
        } else {
          context.commit('SET_AUTH_VALIDATION', error.response.data.errors)
        }
      })
    },
    // проверяем залогиненого пользователя при маунте App
    checkLoggedUser (context) {
      if (localStorage.currentUserId) {
        context.state.appData.currentUser.id = +localStorage.currentUserId
        context.state.appData.currentUser.api_key = localStorage.currentUserKey
        context.state.appData.currentUser.logged_in = localStorage.currentUserLogged

        configMultipart.headers.Authorization = `Bearer ${localStorage.currentUserKey}`
        config.headers.Authorization = `Bearer ${localStorage.currentUserKey}`

        // отправляем проверочный запрос чтобы убедиться в актуальности токена
        usersApi.getCurrentUser().then(response => {
          context.commit('[roles] SET_RIGHTS', response.data.data.roles)
          context.commit('GET_CURRENT_USER_DATA', response.data.data)
          context.dispatch('initialiseMenu')
          // запускаем пинги для обновления статуса онлайн
          this.dispatch('renewUserAuthTime')
        }).catch(() => {
          context.dispatch('logOut').then(() => {
            context.commit('GET_CURRENT_USER_DATA_FAILURE')
            context.commit('SHOW_LOGIN_ERROR_MESSAGE')
          })
        })
      }
    },
    logOut ({ commit }) {
      // при входе и выходе редиректим домой, чтобы не сбивалась логика инициализации меню,
      // так как оно в этих случаях не правильно устанавливает текущий раздел (мутация SET_CURRENT_MENU)
      if (router.currentRoute.path !== '/') {
        router.push({ path: '/' })
      }
      commit('[index] CLEAR_LOGIN_FORM')
      commit('[roles] REMOVE_RIGHTS')
      commit('LOG_OUT')
    },
    loginFormClearValidation ({ commit }, input) {
      commit('LOGIN_FORM_CLEAR_VALIDATION', input)
    },
    renewUserAuthTime () {
      setInterval(() => {
        usersApi.renewAuthTime().then(response => {}).catch(error => {
          console.log('ошибка обновления даты аторизации юзера', error.response ? error.response : error)
        })
      }, 270000)
    },

    // МЕНЮ
    // выпадающее меню текущего пользователя
    toggleHeaderMenu ({ commit }) {
      commit('TOGGLE_HEADER_MENU')
    },
    // меню по дефолту
    initialiseMenu ({ commit }) {
      const currentRootPath = router.currentRoute.path.split('/')[1]
      commit('MENU_INITIALIZE')
      commit('MAIN_MENU_INITIALIZE')
      commit('SET_CURRENT_MENU', currentRootPath)
    },
    toggleMainMenu ({ commit }) {
      commit('TOGGLE_MAIN_MENU')
    },
    switchMenu ({ commit }, data) {
      commit('SWITCH_MENU', data)
    },

    setCurrentMediaBreakPoint ({ commit }) {
      if (window.matchMedia('(max-width: 580px)').matches) {
        commit('SET_CURRENT_MEDIA_BREAKPOINT', 'mobile_start')
      } else if (window.matchMedia('(max-width: 1080px)').matches) {
        commit('SET_CURRENT_MEDIA_BREAKPOINT', 'tablet_start')
      } else {
        commit('SET_CURRENT_MEDIA_BREAKPOINT', 'desktop')
      }
    },
    setCurrentUserAgent ({ commit }) {
      if (navigator.userAgent.toLowerCase().match(/(ipad|iphone)/) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        commit('SET_CURRENT_USER_AGENT', 'IOS')
      }
    }
  },
  modules: {
    dictionaries,
    userRoles,
    userCreatePage,
    userUpdatePage,
    userListPage,
    subordinatesListPage,
    departmentsTreePage,
    departmentCreatePage,
    userGroupsPage,
    positionListPage,
    employmentListPage,
    statusListPage,
    scheduleListPage,
    contractListPage,
    contractUpdatePage,
    contractTypeListPage,
    contractStageListPage,
    contractStatusListPage,
    contractProjectListPage,
    contractorListPage,
    contractorUpdatePage,
    contractorFormListPage,
    contractorStatusListPage,
    contractorTypeListPage
  }
})
